import {
  List,
  ListItem,
  ListItemText,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { DietaryRestriction } from "../../../../../__generated__/graphql";

type AllergensListProps = {
  allergens: DietaryRestriction[];
};
export default function AllergensList({ allergens }: AllergensListProps) {
  return (
    <Table sx={{ width: "unset" }}>
      <TableHead>
        <TableRow>
          <TableCell sx={{ paddingTop: 0, paddingBottom: 0 }}>
            Included Allergens
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <List sx={{ pl: "20px" }}>
          {allergens.map(({ diet }) => (
            <ListItem
              key={diet}
              sx={{
                display: "list-item",
                listStyleType: '"›"',
                padding: 0,
                "& .MuiListItemText-root": {
                  ml: 1,
                },
              }}
            >
              <ListItemText primary={diet.split("@")[1]} />
            </ListItem>
          ))}
        </List>
      </TableBody>
    </Table>
  );
}
